import React from 'react'
import PropTypes from 'prop-types'
import {useSelector} from 'react-redux'
import EditableTask from '#components/a/EditableTask'
import CheckableTask from '#components/a/CheckableTask'
import ReadOnlyTask from '#components/a/ReadonlyTask'
import ArchivedTask from '#components/a/ArchivedTask'

export default function Task(props) {
  const {task, onChangeHandle, backgroundColor, onDelete, postComment} = props

  if (task.archived) {
    return <ArchivedTask task={task} />
  }

  const permissions = useSelector(state => state.authentication.permissions)
  if (permissions.praxisaufgaben.readOnly) {
    return <ReadOnlyTask task={task} />
  }

  if (permissions.praxisaufgaben.check) {
    return <CheckableTask task={task} onChangeHandle={onChangeHandle} />
  }

  if (permissions.praxisaufgaben.edit || permissions.praxisaufgaben.editOwnAbteilungen) {
    return (
      <EditableTask
        task={task}
        backgroundColor={backgroundColor}
        canOnlyEditOwnAbteilungen={permissions.praxisaufgaben.editOwnAbteilungen}
        onDelete={onDelete}
        postComment={postComment}
      />
    )
  }
  return null
}

Task.propTypes = {
  task: PropTypes.object.isRequired,
  onChangeHandle: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  postComment: PropTypes.func,
  backgroundColor: PropTypes.string,
}
